export const APP_NAME = 'Lumnis';

/** Display name shared by the marketing site and dashboard. Routes and run
 * identifiers retain their existing audience/brand keys. */
export const AUDIENCE_RESEARCH_NAME = 'Audience research';
export const APP_DESCRIPTION =
  'See which accounts are in market this week and who can get you in the door (your first meeting within days).';
